import React from 'react'
import BankStore from '../../store/bankstore'
import HeaderSteps from './headersteps'
import UploadKontir from './steps/upload/Kontir';
import UploadRlb from './steps/upload/Rlb';
import Assignment from './steps/assignment'
import Pairing from './steps/Pairing';
import DownloadXml from './steps/downloadxml'
import i18 from '../../i18'
import BaseComponent from '../base'
import api from '../../source/api'
import BankRules from './bankrules'
import SavedPartners from './savedpartners'

class Bank extends BaseComponent {

    constructor(props) {
        super(props)
        this.state = {
            editpartners: false,
            editrules: false,
            hidemenu: false,
            accountant_program_id: null,
            company: null,
            company_id: props.location.match.params.id,
            steps: {
                next: 2,
                current: 1,
                data: {}
            },
            dataVszItems: {},
            dataPaired: [],
            dataUnpaired: {},
            dataProcessed: [],
            dataUnprocessed: []
        }
        this.store = BankStore
    }

    setNextStep = () => {
        this.setStep(this.state.steps.current + 1);
    }

    setStep = (step) => {
        let steps = this.state.steps;
        steps.current = step;
        steps.next = this.state.steps.current + 1;
        this.setState({steps: steps});
    }

    hideStepsMenu = () => {
        this.setState({hidemenu: true})
    }

    prevStep = (step) => {
        let steps = this.state.steps;
        steps.current = step
        steps.next = step + 1
        this.setState({steps: steps})
    }

    componentDidMount = () => {
        window.scrollTo(0, 0);

        api.get({url: 'company/' + this.state.company_id, data: {}}, true).then((response) => {
            this.setState({
                company: response.data,
                accountant_program_id: response.data.accountant_program_id,
            })
        }).catch((error) => {
            console.log(error);
            this._addNotification('Belső hiba lépett fel, kérünk értesítse a fejlesztői csapatot. ERR-CODE-BANK-001', 'error');
        });
    }

    editRules = () => {
        if (this.state.steps.current === 2) {
            this.prevStep(1)
        }
        this.setState({editrules: !this.state.editrules})
    }

    editSavedPartners = back => {
        if (this.state.steps.current === 2 && back) {
            this.prevStep(1)
        }
        this.setState({editpartners: !this.state.editpartners})
    }

    _addNotification = (msg, type, time = 30) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        })
    }

    render() {
        return (
            <section id='bank-upload'>
                {!this.state.editrules && !this.state.editpartners && !this.state.hidemenu ?
                    <HeaderSteps prevStep={(step) => this.prevStep(step)}
                                 currentStep={this.state.steps.current}/> : null}
                <div className={!this.state.editrules && !this.state.editpartners ? 'header' : 'd-none'}>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <h1 className='pull-left'>
                                    {i18.BANK._bank}
                                </h1>
                                <div className='pull-right mt-3'>
                                    {this.state.steps.current === 1
                                        ? <a href='/letoltesek/BankDemo.xlsx' className='table-green-btn ml-1'
                                             target='_blank'>Teszt állomány</a>
                                        : null}
                                    <a onClick={() => this.editSavedPartners(false)} className={this.state.steps.current < 3 ? 'table-green-btn ml-1' : 'd-none'}>{i18.BUTTONS._savedPartners}</a>
                                    <a onClick={() => this.editRules()} className={this.state.steps.current < 3 ? 'table-green-btn ml-1' : 'd-none'}>{i18.BUTTONS._rules}</a>
                                </div>
                            </div>

                            <div className={this.state.steps.current < 2 ? 'col-12' : 'd-none'}>
                                <p>
                                    {i18.BANK._description}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={!this.state.editrules && !this.state.editpartners ? 'upload-body' : 'd-none'}>
                    <div className='container'>
                        <div className={this.state.steps.current === 1 ? 'row' : 'd-none'}>
                            {
                                {
                                    1: <UploadKontir
                                        {...this.props}
                                        step={this.state.steps.current}
                                        setNextStep={() => this.setNextStep()}
                                        setValue={(name, value, error) => this.setValue(name, value, error)}
                                        setBankState={(state) => this.setState(state)}
                                    />,
                                    3: <UploadRlb
                                        {...this.props}
                                        step={this.state.steps.current}
                                        setNextStep={() => this.setNextStep()}
                                        setValue={(name, value, error) => this.setValue(name, value, error)}
                                        setBankState={(state) => this.setState(state)}
                                    />
                                }[this.state.accountant_program_id]
                            }
                        </div>
                    </div>
                    <div className='container-fluid'>
                        <div className={this.state.steps.current === 2 ? '' : 'd-none'}>
                            <Assignment
                                {...this.props}
                                company={this.state.company}
                                step={this.state.steps.current}
                                setNextStep={() => this.setNextStep()}
                                setValue={(name, value, error) => this.setValue(name, value, error)}
                                setBankState={(state) => this.setState(state)}
                            />
                        </div>

                        {this.state.steps.current === 3 ?
                            <Pairing
                                {...this.props}
                                company={this.state.company}
                                step={this.state.steps.current}
                                dataVszItems={this.state.dataVszItems}
                                setNextStep={() => this.setNextStep()}
                                setValue={(name, value, error) => this.setValue(name, value, error)}
                                setBankState={(state) => this.setState(state)}
                            />
                            : null}
                        {this.state.steps.current === 4
                            ? <DownloadXml
                                {...this.props}
                                dataPaired={this.state.dataPaired}
                                dataUnpaired={this.state.dataUnpaired}
                                dataProcessed={this.state.dataProcessed}
                                dataUnprocessed={this.state.dataUnprocessed}
                                dataVszItems={this.state.dataVszItems}
                                step={this.state.steps.current}
                                setNextStep={() => this.setNextStep()}
                                hideStepsMenu={() => this.hideStepsMenu()}
                                setValue={(name, value, error) => this.setValue(name, value, error)}
                                setStep={(step) => this.setStep(step)}
                                setBankState={(state) => this.setState(state)}
                            />
                            : null}
                    </div>
                </div>
                <div className={this.state.editrules ? 'upload-body' : 'd-none'}>
                    <BankRules
                        state={this.state.bank}
                        {...this.props}
                        rerender={this.state.editrules}
                        editRules={() => this.editRules()}
                        company={this.state.company}
                        company_id={this.state.company_id}
                        setValue={(name, value, error) => this.setValue(name, value, error)}/>
                </div>
                <div className={this.state.editpartners ? 'upload-body' : 'd-none'}>
                    <SavedPartners
                        rerender={this.state.editpartners}
                        editSavedPartners={(back) => this.editSavedPartners(back)}
                        company_id={this.state.company_id}/>
                </div>
            </section>
        )
    }
}

export default Bank


// WEBPACK FOOTER //
// ./src/components/bank/bank.js